// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"ro-z","landingPageVideo":"so-z","play":"to-z","iframeVideo":"uo-z","playHidden":"vo-z","fullwidth":"wo-z"};